package io.horion.auth.api.models.domain

enum class LoginMethod(val method: String) {
    EMAIL("EMAIL"),
    PHONE("PHONE")
}